<template>
  <GuideIndex />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center',
  middleware: ['naver-ads', 'kakao-pixel']
})

const { ogUrl, ogTitle, keyword } = useSeo()

useSeoMeta({
  title: '가이드',
  description:
    'eSIM, USIM 구매 후  설치, 활성화, 제거하는 방법까지 알려드릴게요!',
  ogType: 'website',
  ogUrl: () => ogUrl('guide'),
  ogTitle: () => ogTitle('가이드'),
  ogDescription:
    'eSIM, USIM 구매 후  설치, 활성화, 제거하는 방법까지 알려드릴게요!',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('가이드'),
  twitterDescription:
    'eSIM, USIM 구매 후  설치, 활성화, 제거하는 방법까지 알려드릴게요!',
  keywords: () =>
    keyword(
      'eSIM설치, eSIM활성화, eSIM제거, 가이드, eSIM가이드, 이심가이드, USIM가이드, 유심가이드'
    )
})
</script>
